"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIframeSettingsFromLocation = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

var _dotObject = _interopRequireDefault(require("dot-object"));

var _lodash = _interopRequireDefault(require("lodash.merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIframeSettingsFromLocation = function getIframeSettingsFromLocation() {
  var parsedQueryString = _queryString.default.parse(window.location.search);

  var settings = {
    isIframe: false,
    query: {},
    disabledFilter: []
  };

  if (!parsedQueryString.iframe) {
    return settings;
  }

  var valuesAsObjects = [];
  Object.keys(parsedQueryString).forEach(function (key) {
    if (key.startsWith('iframe.')) {
      var keyWithoutIframe = key.replace(/^iframe\./, '');

      var object = _dotObject.default.str(keyWithoutIframe, parsedQueryString[key], {});

      valuesAsObjects.push(object);
    }
  });

  _lodash.default.apply(void 0, [settings].concat(valuesAsObjects));

  settings.isIframe = true;

  if (typeof settings.disabledFilter === 'string') {
    settings.disabledFilter = [settings.disabledFilter];
  }

  return settings;
};

exports.getIframeSettingsFromLocation = getIframeSettingsFromLocation;


//////////////////
// WEBPACK FOOTER
// ./client/lib/reducer/iframe.js
// module id = 601
// module chunks = 0